var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.902,
    height: 41.821,
    viewBox: "0 0 41.902 41.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(-3240.236 -6967.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M3261.6,7009.784h-1.637a2.22,2.22,0,0,0-.316-.067,19.369,19.369,0,0,1-7.305-1.9,20.652,20.652,0,0,1-11.772-15.307c-.156-.795-.222-1.608-.33-2.413v-2.451c.106-.792.181-1.589.323-2.374a20.981,20.981,0,0,1,23.172-17.164,21.505,21.505,0,0,1,12.819,5.814,17.454,17.454,0,0,1,5.221,9.188c.164.768.247,1.553.367,2.33v1.879c-.053.347-.1.694-.16,1.04a11.365,11.365,0,0,1-4.265,7.286,11.677,11.677,0,0,1-7.553,2.529c-1.281,0-2.564-.032-3.844.012a3.417,3.417,0,0,0-3.228,4.5,5.954,5.954,0,0,0,.94,1.6,3.555,3.555,0,0,1-.061,4.115A3.863,3.863,0,0,1,3261.6,7009.784Zm-13.153-27.87a3.477,3.477,0,1,0,3.42,3.533A3.484,3.484,0,0,0,3248.443,6981.914Zm25.6,0a3.477,3.477,0,1,0,3.431,3.525A3.471,3.471,0,0,0,3274.044,6981.914Zm-15.2-5.946a3.473,3.473,0,0,0-3.681-3.347,3.474,3.474,0,1,0,3.681,3.347Zm8.123,3.6a3.477,3.477,0,1,0-3.446-3.475A3.5,3.5,0,0,0,3266.965,6979.565Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.8076ef89d2b7224f5b3494cf65e9a569.svg";
export { ForwardRef as ReactComponent };